import { Controller } from "@hotwired/stimulus"
import { upsertPerformanceQueue } from "../../pwa/offline_queue"
import { showPwaFlash } from "../../pwa/show_pwa_flash"
import { applyOfflineUpdateToForm, syncOfflineUpdateAcrossForms } from "../../pwa/performance_summary"

// Connects to data-controller="confirm"
export default class extends Controller {
  async confirm(event) {
    const message = "今日の作業内容を実績として確定します。よろしいですか？"

    if (!window.confirm(message)) {
      event.preventDefault()
      event.stopImmediatePropagation()
      return
    }

    if (!navigator.onLine) {
      event.preventDefault()
      event.stopImmediatePropagation()

      const form = this.element.form || this.element.closest("form")
      if (!form) return

      const formData = new FormData(form)
      const payload = {}

      for (let [key, value] of formData.entries()) {
        if (payload[key]) {
          if (!Array.isArray(payload[key])) {
            payload[key] = [payload[key]]
          }
          payload[key].push(value)
        } else {
          payload[key] = value
        }
      }

      payload["_url"] = form.action
      payload["_method"] = (form.querySelector("[name='_method']")?.value || "PATCH").toUpperCase()

      await upsertPerformanceQueue({
        type: "performance_update",
        payload: payload
      })

      this.#hideUnsavedAlert(form)
      this.#hideMatchingGroupAlert(form.action)
      applyOfflineUpdateToForm(form)
      this.#applyToMatchingGroupForm(form.action)

      showPwaFlash("オフラインです。オンライン復帰後に自動保存されます。", "success")
    }
  }

  #hideUnsavedAlert(form) {
    form.querySelectorAll("[data-unsaved-alert]").forEach(el => el.remove())
  }

  #hideMatchingGroupAlert(actionUrl) {
    document.querySelectorAll("[data-group-performance-form]").forEach(form => {
      if (form.action === actionUrl) this.#hideUnsavedAlert(form)
    })
  }

  #applyToMatchingGroupForm(actionUrl) {
    const sourceForm = this.element.form || this.element.closest("form")
    document.querySelectorAll("[data-group-performance-form]").forEach(form => {
      if (form.action === actionUrl) syncOfflineUpdateAcrossForms(sourceForm, form)
    })
  }
}
